import * as React from 'react'
import { cn } from '@/lib/utils'
import { FIELD_CLASSES } from './input'

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

/**
 * A styled multi-line input, matching `Input`'s border, focus ring and density.
 *
 * Separate from `Input` rather than a variant of it because the element is a
 * different one: a textarea has `rows`, wraps, and grows, and squeezing both
 * through one component would mean a prop that is meaningless half the time.
 */
export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, rows = 3, ...props },
  ref,
) {
  return (
    <textarea
      rows={rows}
      className={cn(
        FIELD_CLASSES,
        'min-h-[84px] resize-y px-3 py-[9px]',
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
